export default "__VITE_ASSET__DD2x9_Hr__"